<template>
    <div class="referrals-body__list">
        <table>
            <tr>
                <th>Your Friends</th>
                <th>Status</th>
            </tr>
            <tr v-for="referral in referralsList" :key="`referrals-${referral.id}`">

                <!-- If referral has a user model -->
                <td v-if="referral.invited_user">
                    <img :src="referral.invited_user.large_profile">
                    {{ referral.invited_user.full_name }}
                </td>

                <!-- If not -->
                <td v-else>
                    <span class="person-wrap">
                        <svg class="person"><use xlink:href="#person"></use></svg>
                    </span>
                    <span v-if="referral.email" v-text="referral.email"></span>
                    <span v-if="referral.tel" v-text="referral.tel"></span>
                </td>

                <td v-text="printStatus(referral)" class="text-capitalize"></td>

                <!-- Inactive Action -->
                <td v-if="referral.status == 'inactive'" class="controls"></td>

                <!-- Member Action -->
                <td v-if="referral.status == 'member'" class="controls">
                    <a :href="`/${referral.invited_user.username}`">View Profile</a>
                </td>

                <!-- Pending Action -->
                <td v-if="referral.status == 'pending'" class="controls">
                    <div class="form-controls">
                        <CancelButton :referral="referral"></CancelButton>
                        <ReminderButton :referral="referral"></ReminderButton>
                    </div>
                </td>
            </tr>
        </table>

        <div class="referrals-body__info">
            <h3><span>100</span>in <a href='/account/credits'>Booking Credit</a></h3>
            <p>When you invite someone to join the club and they become a member, you’ll get $100 in booking credit, good for use on any future trip booked with Well Traveled. Booking credit expires one year from issue date.</p>
        </div>

    </div>
</template>

<script>

import CancelButton from './CancelButton.vue'
import ReminderButton from './ReminderButton'

export default {

    props: ['referrals', 'referralsAsMembers'],

    components:{
        CancelButton,
        ReminderButton
    },

    data(){
        return {
            referralsList: this.referrals,
        }
    },

    created(){
        eventBus.$on('update-referrals', referrals => this.referralsList = referrals)
    },

    methods: {
        printStatus(referral) {
            if (referral.invited_user) {
                if (['Cancelled Inactive', 'Cancelled Trial'].includes(referral.invited_user.wt_status)) {
                    return 'Inactive'
                }
                if (referral.invited_user.wt_status == 'Trial') {
                    return 'Trailing'
                }
            }
            return referral.status
        }
    },
}
</script>
